// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-b5358be5] .p-datatable .p-rowgroup-header{background:#dfe3e9 !important}[data-v-b5358be5] .p-datatable .p-rowgroup-header td{padding:1px 0 !important}[data-v-b5358be5] .p-datatable .p-rowgroup-header:first-child{display:none}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
